// extracted by mini-css-extract-plugin
export default {"headerContentWrapper":"style_headerContentWrapper__vmo96","link":"style_link__S0g-k","logo":"style_logo__EP6ji","menuWrapper":"style_menuWrapper__t0xPk"};